import { AppState } from "../../../../redux-configuration/AppState";
import { ChatMessage } from "../../../domain/entities/chatMessage";

export const loadNewChatMessagesLoadingSelector = (appState: AppState): boolean => appState.messaging.message.newMessages.loading
export const loadNewChatMessagesErrorSelector = (appState: AppState): string | undefined => appState.messaging.message.newMessages.error
export const newChatMessagesSelector = (appState: AppState): ChatMessage[] | null => appState.messaging.message.newMessages.messages
